import common from './common';
import settingsContainer from './settingsContainer';
import mainComponent from './mainComponent';
import dishesContainer from './dishesContainer';
import editingContainer from './editingContainer';
import monthlyExpensesContainer from './monthlyExpensesContainer';
import ordersHistoryContainer from './ordersHistoryContainer';
import dataTables from './dataTables';
import ordersCountContainer from './ordersCountContainer';
import ordersListContainer from './ordersListContainer';
import dishRatingsContainer from './dishRatingsContainer';
import usersBalancesContainer from './usersBalancesContainer';
import manageProvidersModal from './manageProvidersModal';

export default {
  common,
  settingsContainer,
  mainComponent,
  dishesContainer,
  editingContainer,
  monthlyExpensesContainer,
  dataTables,
  ordersCountContainer,
  ordersListContainer,
  dishRatingsContainer,
  ordersHistoryContainer,
  usersBalancesContainer,
  manageProvidersModal,
};
